<div class="pointer-events-none absolute inset-0 z-0 block" aria-hidden="true">
    <svg class="absolute inset-0 h-full w-full overflow-visible" fill="none">
        <path [attr.d]="path()" stroke="#ec6602" stroke-width="2" />
        <circle [attr.cx]="startPoint().x" [attr.cy]="startPoint().y" r="6" fill="#ec6602" />
        <circle [attr.cx]="endPoint().x" [attr.cy]="endPoint().y" r="6" fill="#ec6602" />
    </svg>
</div>
